import { useContext, useMemo } from 'preact/hooks';
import { ApplicationContext } from './use-application-setup';

export const useUwBranding = () => {
  const { whiteLabelOptions, customBrandingOptions } = useContext(ApplicationContext);

  const isWhiteLabeled = useMemo(() => Boolean(
      whiteLabelOptions?.wlHideLogo
      || customBrandingOptions?.custom_logo_image_link
      || customBrandingOptions?.custom_logo_image_path,
    ),
    [whiteLabelOptions, customBrandingOptions]);

  return {
    isWhiteLabeled,
  };
};
